<template>
  <div class="RegList-dom" @click="onClick">
    <div class="item-img">
      <img :src="img" />
    </div>
    <div class="item-right">
      <div class="title">
        <span>{{ title }}</span>
        <span style="font-weight:500">{{ amount || "0.00" }}</span>
      </div>
      <!-- <div class="time">
        <p>直播 |</p>
        <van-count-down :time="formatsecs(time)" format="DD天HH时mm分" />
      </div> -->

      <div class="item-bottom">
        <p>{{ itemExplain || "注册成功后凭直播码收看" }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RegList",
  props: {
    img: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    regJumpUrl: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    amount: {
      type: Number,
      default: 0
    },

    time: {
      type: String,
      default: ""
    },
    itemExplain: {
      type: String,
      default: ""
    }
  },
  methods: {
    formatsecs: function(value) {
      const timeNum = Math.floor(
        new Date(value).getTime() - new Date().getTime()
      );
      return timeNum >= 0 ? timeNum : 0;
    },
    onClick: function() {
      if (!this.time) {
        this.$router.push({
          path: "/conference/register",
          query: {
            code: this.$route.query.code,
            id: this.id,
            regJumpUrl: this.regJumpUrl
          }
        });
      } else {
        const newTime = new Date().getTime();
        const listTime = new Date(this.time.replace(/-/g, "/")).getTime();
        if (Math.floor(listTime - newTime) > 0) {
          this.$router.push({
            path: "/conference/register",
            query: {
              code: this.$route.query.code,
              id: this.id,
              regJumpUrl: this.regJumpUrl
            }
          });
        } else {
          this.$toast.fail("此类报名已过期，请选择其他类型");
        }
      }
    }
  }
};
</script>
<style scoped>
.RegList-dom {
  display: flex;
  padding: 10px;

  border-bottom: 1px solid #dcdcdc;
}
.item-img {
  width: 156px;
  height: 88px;
  border-radius: 4px;
  overflow: hidden;
}
.item-img img {
  width: 100%;
  height: 100%;
}
.item-right {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-left: 10px;
  text-align: left;
}
.item-right p {
  padding: 0;
  margin: 0;
}

.item-right .title {
  flex: 1;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  font-weight: 700;
  line-height: 18px;

  color: #161616;
}
.item-bottom {
  font-size: 12px;
  font-weight: 400;
  line-height: 19px;
  color: #666;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  text-overflow: ellipsis;

  display: -webkit-box;

  -webkit-line-clamp: 3;

  overflow: hidden;

  /*! autoprefixer: off */

  -webkit-box-orient: vertical;
}
.item-right .time {
  font-size: 12px;
  font-weight: 400;
  line-height: 19px;
  color: #666;
}
.clickon-dom {
  display: flex;
  align-items: center;
}
.clickon-dom .clickon-icon {
  margin-right: 6px;
}
.time {
  display: flex;
}
.time >>> .van-count-down {
  color: #666;
  margin-left: 4px;
}
</style>
